import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiEmailModule } from '../lib/shared-ui-email.module'
import { EmailDocsComponent } from './email-docs/email-docs.component'
import { EmailExampleComponent } from './email-docs/email-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiEmailModule
  ],
  declarations: [
    EmailDocsComponent,
    EmailExampleComponent
  ],
  exports: [
    EmailDocsComponent
  ]
})
export class SharedUiEmailDocsModule {}
